module.exports = __webpack_public_path__ + "aa47e863e53311f71160e36ef32e24c7.svg";